import SearchDataGridWithTotalRow from 'components/search/search-data-grid/search-data-grid-with-total-row/search-data-grid-with-total-row.component';
import EmailPulseDataGridToolbar from '../email-pulse-data-grid-toolbar/email-pulse-data-grid-toolbar.component';
import { useSearchParamsContext } from 'components/search/search.hooks';
import { getFileName } from '../email-pulse.utils';
import type { GridColDef, GridSortDirection } from '@mui/x-data-grid-premium';
import { EmailPulseExportMutationHook } from '../email-pulse.types';

type EmailPulseDataGridProps = {
  'data-testid': string;
  /** Query name for fetching data */
  queryName: string;
  /** Column definitions for the data grid */
  columns: GridColDef[];
  /** Initial column visibility model */
  columnVisibilityModel: Record<string, boolean>;
  /** Export file type identifier (e.g., 'OVERVIEW', 'MESSAGES', 'OFFERS') */
  exportFileType:
    | 'OVERVIEW'
    | 'MESSAGES'
    | 'OFFERS'
    | 'ORDERS'
    | 'GIFT_CARDS'
    | 'SECURITY';
  /** Export mutation hook from RTK Query */
  useExportMutation: EmailPulseExportMutationHook;
  /** Optional column name to pin to the left */
  pinnedLeftColumn?: string;
};

const EmailPulseDataGrid = ({
  queryName,
  columns,
  columnVisibilityModel,
  exportFileType,
  useExportMutation,
  pinnedLeftColumn,
  ...rest
}: EmailPulseDataGridProps) => {
  const { searchParams } = useSearchParamsContext();

  return (
    <SearchDataGridWithTotalRow
      columns={columns}
      toolbar={{
        columns: {
          enabled: true,
        },
      }}
      initialState={{
        columns: {
          columnVisibilityModel,
        },
        pinnedColumns: pinnedLeftColumn
          ? { left: [pinnedLeftColumn] }
          : undefined,
        sorting: {
          sortModel: [
            {
              field: searchParams.sortBy?.value as string,
              sort: (
                searchParams.sortDirection?.value as string
              )?.toLowerCase() as GridSortDirection,
            },
          ],
        },
      }}
      slots={{
        toolbar: EmailPulseDataGridToolbar,
      }}
      slotProps={{
        toolbar: {
          toolbar: {
            export: {
              query: useExportMutation as any,
              fileName: getFileName(
                {
                  startDate: searchParams.startdate.value as string,
                  endDate: searchParams.enddate.value as string,
                },
                exportFileType,
              ),
              queryName,
              filteredSearchParams: [
                'count',
                'page',
                'sortBy',
                'sortDirection',
              ],
              includeColumnsField: true,
            },
          },
        },
      }}
      queryName={queryName}
      {...rest}
    />
  );
};

export default EmailPulseDataGrid;
